import type { ItemId } from '@finsim/model';
import { useUnit } from 'effector-react';
import { TrendingUp } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { $project } from '../../entities/project';
import { Button, EditOnly } from '../../shared/ui';
import { returnsAnalysisRequested } from './model';

/**
 * Opens the Returns view; editing only when it would first set up an investment (for the asset
 * `itemId`, or the whole variant).
 */
export function AnalyseReturnsButton({ name, itemId }: { name: string; itemId?: ItemId }) {
  const { t } = useTranslation();
  const [project, analyse] = useUnit([$project, returnsAnalysisRequested]);
  const exists =
    itemId === undefined
      ? (project?.investments.length ?? 0) > 0
      : project?.items[itemId]?.investment !== undefined;
  const button = (
    <Button
      size="sm"
      variant="ghost"
      leadingIcon={<TrendingUp />}
      onClick={() => {
        analyse(itemId === undefined ? { name } : { name, itemId });
      }}
    >
      {exists ? t('returns.open') : t('returns.analyse')}
    </Button>
  );
  return exists ? button : <EditOnly>{button}</EditOnly>;
}
